export class HubEvent {
  public _id: string;
  public id: string;
  public hubName?: string;
  public title: string;
  public name: string;
  public image?: string;
  public startTime?: string;
  public endTime?: string;
  public eventTimes?: any[];
  public startTimeText?: string;
  public endTimeText?: string;
  public eventTimesText?: any[];
  public timezone?: string;
  public timezoneFormatter?: string;
  public address?: any;
  public venue?: string;
  public venueInfo?: {
    name: string;
    rating: number;
    reviews: number;
    link: string;
  };
  public attendingCount?: number;
  public isChoice?: boolean;
  public isCustom?: boolean;
  public isLocked: boolean; // locked event will not be updated in the next event delivery
  public isToBeExport?: boolean;
  public pinnedTime: Date;
  public isApproved: boolean;
  public hostFacebookLink?: string;
  public ticketUri?: string;
  public ticketInfo?: {
    source: string;
    link: string;
    link_type: string;
  }[];
  public description?: string;
  public lat: number;
  public lng: number;
  public owner: {
    name: string;
    id: string;
  };
  public startTimeFormatted: string;
  public endTimeFormatted: string;
  public isNoTime: boolean;
  public isManuallyCreated: boolean;
  public isHubCreated: boolean;
  public isPromotionImage: boolean;
  public promotionLink: string;
  public hostLink: string;
  public eventLink: string;
  public isFacebookEvent: boolean;
  public imageLink: string;
  public imageFile: File;
  public socialName: string;
  public socialId: string; // id from source, for example, Eventbrite event id
  public category: string;
  public cover?: {
    source?: string;
    style?: string;
    large?: string;
    isDefault?: boolean;
    isLarge?: boolean;
  };
  public mapIcon?: string;
  public categoryList?: string[];
  public isOnlineEvent: boolean;
  public isHybridEvent: boolean;
  public isHideTicketUrl: boolean;
  public from?: string;
  public organizerEmail?: string;
  public isCancelled?: boolean;
  public nameId?: string;
  public changeHistory: {
    userName: string;
    changedAt: string;
  }[];
  public isSimilarWithClientEvent: boolean;
  public createdAt: string;
}

export class EditorChoiceDataSource {
  public editorChoiceForEvent: string;
  public editorChoiceForPlace: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.event.ts